/**
 * @generated SignedSource<<03baab2a82cd15180588499274727242>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UpdateChatMessageInput = {
  chatMessageId: string;
  clientMutationId?: string | null | undefined;
  message?: string | null | undefined;
};
export type ChatThreadItem_UpdateChatMessageMutation$variables = {
  input: UpdateChatMessageInput;
};
export type ChatThreadItem_UpdateChatMessageMutation$data = {
  readonly updateChatMessage: {
    readonly chatMessage: {
      readonly editedAt: string | null | undefined;
      readonly id: string;
      readonly message: string;
    } | null | undefined;
  } | null | undefined;
};
export type ChatThreadItem_UpdateChatMessageMutation = {
  response: ChatThreadItem_UpdateChatMessageMutation$data;
  variables: ChatThreadItem_UpdateChatMessageMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateChatMessagePayload",
    "kind": "LinkedField",
    "name": "updateChatMessage",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ChatMessage",
        "kind": "LinkedField",
        "name": "chatMessage",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "editedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ChatThreadItem_UpdateChatMessageMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ChatThreadItem_UpdateChatMessageMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c16c8d70ac117e0a6d3b44bf2c7e300b",
    "id": null,
    "metadata": {},
    "name": "ChatThreadItem_UpdateChatMessageMutation",
    "operationKind": "mutation",
    "text": "mutation ChatThreadItem_UpdateChatMessageMutation(\n  $input: UpdateChatMessageInput!\n) {\n  updateChatMessage(input: $input) {\n    chatMessage {\n      id\n      editedAt\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4e2721c3d9b4ff07e7a6b01aa89e7c84";

export default node;
